import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Logo from '../components/Logo/Logo';
import Link from '../../../shared/components/Link/Link';
import sortLinks from '../helpers/sortLinks';
import BasicTemplate from '../templates/BasicTemplate';


class SiteFooter extends Component {
  static getDomId() {
    return 'slot_site_footer';
  }

  render() {
    const {
      logo,
      template,
      disclaimer,
      categoryLinks,
    } = this.props;

    // TODO: remove template file once all utilities are migrated to site footer
    if (template === 'basic') {
      return <BasicTemplate {...this.props} />;
    }

    return (
      <div className="se-tier">
        <div className="site-footer">
          <div className="site-footer__container">
            <div className="site-footer__link-list">
              {sortLinks(categoryLinks).map(({ title, id, links }) => (
                <div key={id} className="site-footer__link-category">
                  <div className="site-footer__link-category-title">{title}</div>
                  {links.map(({
                    url, external, display, id, class: className,
                  }) => (
                    <Link
                      key={id}
                      href={url}
                      external={external}
                      className={`site-footer__link ${className || ''}`}
                    >
                      {display}
                    </Link>
                  ))}
                </div>
              ))}
            </div>
            <Logo {...logo} />
          </div>
        </div>
        <div className="site-footer__disclaimer">
          <div className="se-container">
            <div className="site-footer__disclaimer-text">
              &copy; Uplight,&nbsp;
              {new Date().getFullYear()}
              . All Rights Reserved.
            </div>
            {disclaimer && <div className="site-footer__disclaimer-text">{disclaimer}</div>}
          </div>
        </div>
      </div>
    );
  }
}

SiteFooter.propTypes = {
  template: PropTypes.string,
  disclaimer: PropTypes.string,
  logo: PropTypes.shape({}).isRequired,
  categoryLinks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

SiteFooter.defaultProps = {
  template: '',
  disclaimer: '',
};

export default SiteFooter;
